import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gurudwara',
  templateUrl: './gurudwara.component.html',
  styleUrls: ['./gurudwara.component.scss']
})
export class GurudwaraComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
